import * as queryString from 'query-string';

let q: any = {};

export function parseQuery() {
    q = queryString.parse(location.search);
}

export default function query(): any {
    return q;
}


// WEBPACK FOOTER //
// ./src/router/query.ts